<template>
  <div class="forgetBox">
    <div class="forgetArea">
      <el-button type="primary" @click="$router.push('/login')"
        >{{ $t('return') }}</el-button
      >
      <el-steps :active="stopActive" simple>
        <el-step :title="$t('method1')" icon="el-icon-edit"></el-step>
        <el-step :title="$t('method2')" icon="el-icon-edit"></el-step>
        <el-step :title="$t('reset')" icon="el-icon-finished"></el-step>
        <el-step :title="$t('setsuccess')" icon="el-icon-check"></el-step>
      </el-steps>

      <div class="box selVerify" v-if="stopActive === 0">
        <div>
          <el-button type="primary" @click="changeVerify(1)">{{
            $t("phoneset")
          }}</el-button>
        </div>

        <div>
          <el-button type="primary" @click="changeVerify(2)">{{
            $t("emailset")
          }}</el-button>
        </div>
      </div>

      <div class="box" v-if="stopActive === 1">
        {{  (verifyMode == 1 ? $t('sjh') : $t('dzyx'))}}
        <el-form ref="form" class="formBox" :model="form" label-width="130px">
          <el-form-item
            :label="
             (verifyMode == 1 ? $t('sjh') : $t('dzyx'))
            "
          >
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item :label="$t('qingShuRu')">
            <div class="flex center-row lineYzm">
              <el-input v-model="form.value"></el-input>
              <el-button
                type="warning"
                :disabled="disabled"
                @click="sendcode"
                class="sendcode"
                >{{ btntxt }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label=" ">
            <el-button @click="stopActive = 0">{{ $t('back') }}</el-button>

            <el-button type="primary" @click="OK" class="confirmBtn">{{
              $t("queDing")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="box" v-if="stopActive === 2">
        <el-form ref="form" class="formBox" :model="form" label-width="130px">
          <el-form-item :label="$t('nps')">
            <el-input type="password" v-model="form.newPassword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('npsw')">
            <el-input type="password" v-model="form.confirmPassword"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button @click="stopActive = 1">{{ $t('back') }}</el-button>
            <el-button type="primary" @click="modify" class="confirmBtn">{{
              $t("queDing")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="box" v-if="stopActive === 3">
        <div class="suss">
          <i class="el-icon-circle-check mt50"></i> <br />
          <span class="mt20 fz12 cm">{{ $t("xiuGaiChengGong") }}</span
          ><br />
          <el-button type="primary" @click="toLogin" class="confirmBtn mt50"
            >{{ $t("login1") }}>></el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendValidate, sendValidateEmail, updatePassword } from "@/api/user";
import website from "@/config/website";
export default {
  data: function() {
    return {
      stopActive: 0,
      disabled: false,
      time: 60,
      verifyMode: 1,
      btntxt: this.$t("login.msgText"),
      code: "ali-validate",
      id: "",
      form: {
        phone: "",
        value: "",
        newPassword: "",
        confirmPassword: ""
      }
    };
  },
  methods: {
    changeVerify(val) {
      this.verifyMode = val;
      this.stopActive = 1;
    },
    sendcode() {
      this.time = 60;
      if (!this.form.phone) {
      
          (this.verifyMode == 1 ? this.$t("sjh") : this.$t("dzyx"));

        return;
      }
      // debugger
      if (this.verifyMode === 1) {
        sendValidate({
          phone: this.form.phone,
          code: this.code,
          tenantId: website.tenantId
        }).then(res => {
          console.log(res);
          this.timer();
          if (res.data.code == 200) {
            this.id = res.data.data.id;
            this.$message.success(this.$t("dxfscg"));
          }
        });
      } else {
        sendValidateEmail({
          email: this.form.phone
        }).then(res => {
          console.log(res);
          this.timer();
          if (res.data.code == 200) {
            this.id = res.data.data.id;
            this.$message.success(this.$t("yjfs"));
          }
        });
      }
    },
    //发送手机验证码倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        this.time--;
        this.btntxt = this.time + "s";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = this.$t("login.msgText");
        this.disabled = false;
      }
    },
    OK() {
      if (!this.form.phone) {
        this.$message.error(
          this.$t("qingShuRu") +
            (this.verifyMode == 1 ? this.$t("sjh") : this.$t("dzyx"))
        );
        return;
      }
      if (!this.form.value) {
        this.$message.error(this.$t("qingShuRu"));
        return;
      }
      this.stopActive = 2;
    },
    modify() {
      if (!this.form.newPassword) {
        this.$message.error(this.$t("mmbnwk"));
        return;
      }
      if (this.form.confirmPassword !== this.form.newPassword) {
        this.$message.error(this.$t("mmbnwk1"));
        return;
      }
      let obj = {
        id: this.id,
        value: this.form.value,
        password: this.form.newPassword
      };
      if (this.verifyMode === 1) {
        obj.phone = this.form.phone;
      } else {
        obj.email = this.form.phone;
      }
      updatePassword(obj).then(res => {
        console.log(res);
        this.stopActive = 3;
      });
    },
    toLogin() {
      this.$router.push({ path: "/login" });
    }
  }
};
</script>

<style lang="scss" scope>
.selVerify {
  text-align: center;
  button {
    width: 30vw;
    display: block;
    margin: 40px auto 0;
  }
}
.forgetArea {
  margin: 0px auto 0;
  width: 80%;
  padding-top: 120px;
}

.formBox {
  width: 40%;
  margin: 40px auto 0;
  .lineYzm {
    .el-button {
      width: 120px;
    }
  }
}
.lineYzm .el-input {
  flex: 1;
}
.confirmBtn {
  width: 60%;
  margin: 20px 0% 0;
}
.suss {
  text-align: center;
  .el-icon-circle-check {
    font-size: 60px;
    color: #01aaa7;
  }
  .el-button {
    width: 120px;
  }
}
</style>
